import { AbstractControl } from '@angular/forms';

//nonNegativeIntegerValidator validates that the input contains only integers and not negative
export function nonNegativeIntegerValidator(control: AbstractControl): { [key: string]: any } {
  if (!control.value) {
    return null;
  }
  const r = new RegExp(/^[0-9]+$/);
  return r.test(control.value) ? null : { pattern: 'invalid' };
}

//positiveIntegerValidator validates that the input contains positive integers only
export function positiveIntegerValidator(control: AbstractControl): { [key: string]: any } {
  if (control.value) {
    return +control.value > 0 ? null : { pattern: 'invalid' };
  }
  // return null if control value is null
  return null;
}

export function positiveIntegerWithMaxValidatorBuilder(
  max: number,
): (control: AbstractControl) => { [key: string]: any } {
  return (control: AbstractControl) => {
    if (control.value) {
      return +control.value > 0 && +control.value <= max ? null : { pattern: 'invalid' };
    }
    // return null if control value is null
    return null;
  };
}
